import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ModalPortal from "components-new/ModalPortal";
import sass from "pages/StepPages/StepFour/One/Tables/TableNavigate/DescriptionTable/desc.module.sass";
import { Button } from "components/shared";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";
import { IDescriptionTechTableNew } from "pages/StepPages/StepFour/One/Tables/models";
import { useValidate } from "hooks/useValidate";
import InputTemp from "components-new/InputTemp";
import { ReactComponent as ImageIcon } from "images/FileImage.svg";
import { ITableContent } from "pages/StepPages/StepFour/One/Tables/TableNavigate/DescriptionTable/DescriptionTable";
import Counter from "components-new/Counter";
import TextArea from "components-new/Textarea";
import useDebounce from "hooks/useDebounce";
import { organizationAPI } from "libs/apiClient/Organization";
import { directoryAPI } from "libs/apiClient/Directory";

export function getKeyByValue(object: any, value: any) {
	let prop: keyof typeof object;
	for (prop in object) {
		if (object.hasOwnProperty(prop)) {
			if (object[prop] === value) return prop;
		}
	}
}

/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
export const AcceptImage: React.FC<{
	image: { file?: File; mode: "ARCHITECTURE" | "STRUCTURE" };
	close: () => void;
	ok: () => void;
}> = ({ close, ok, image }) => {
	const [load, setLoad] = useState(true);
	const params = useParams();
	return (
		<ModalPortal outSide={false} handleClose={close} title={load ? "" : "Изображение прикреплено! Завершите настройку"}>
			<div className={sass.modal_content_center}>
				{/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
				{load ? (
					<ImageIcon width={75} height={75} />
				) : (
					// eslint-disable-next-line jsx-a11y/img-redundant-alt
					<img
						alt={"image"}
						src={(() => {
							const blob = new Blob([image.file!]);
							return URL.createObjectURL(blob);
						})()}
						width={75}
						height={75}
						onClick={() => {
							let img = new Image();
							img.src = URL.createObjectURL(image.file!);

							let w: Window | null = window.open("");
							if (w) {
								w.document.write(img.outerHTML);
							}
						}}
					/>
				)}
				{load ? (
					<div className={sass.loader}>
						Загружаем изображение
						<div className={sass.loader_wrapper}>
							<div onAnimationEnd={() => setLoad(false)} />
						</div>
					</div>
				) : (
					<p>{image.file!.name}</p>
				)}
			</div>
			{!load && (
				<div className={sass.btns}>
					<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
						Отменить
					</Button>
					<Button
						onClick={() => {
							if (image) {
								const file = new FormData();
								file.append("file", image.file!);
								organizationAPI
									.objectSystemPictureCreate(Number(params.threadId), { target: image.mode }, { file: image.file })
									.then(ok);
							}
						}}>
						Готово
					</Button>
				</div>
			)}
		</ModalPortal>
	);
};

interface IInit {
	id?: number;
	type: string;
	count: number;
	from: string;
	name: string;
	fullName?: string;
}

const init: IInit = {
	id: undefined,
	type: "",
	count: 1,
	from: "",
	name: "",
	fullName: "",
};

interface IOptionsMeans {
	from: string;
	influence: string;
	id: number;
	type: string;
}

export const fromTable = {
	SOFTWARE: "Программное обеспечение по ведению данных",
	MEAN: "Перечень основных технических средств и систем",
};

export const ModalTech: React.FC<{
	ok: (data: IDescriptionTechTableNew, mode: "create" | "edit") => void;
	target: { active: boolean; data: null | IDescriptionTechTableNew };
	close: () => void;
}> = ({ target, close, ok }) => {
	const [tech, setTech] = useState(init);
	const [options, setOptions] = useState<IOptionsMeans[]>([]);
	const params = useParams();
	useEffect(() => {
		if (target.data) {
			const from = fromTable[target.data.from as keyof typeof fromTable];
			const newData = {
				...target.data,
				from,
				fullName: `${target.data.type} ${target.data.name} (${from})`,
			};
			setTech(newData);
		} else {
			setTech(init);
		}
		return () => {
			setTech(init);
		};
	}, [target]);

	const { error, validate } = useValidate(tech, ["type"], () => {
		if (target.data) {
			ok(tech, "edit");
		} else {
			ok(tech, "create");
		}
	});

	const [counter, setCounter] = useState({
		min: 1,
		max: 9999,
	});

	useEffect(() => {
		if (target.data !== null) {
			setCounter((prevState) => ({ ...prevState, min: 0 }));
		} else {
			setCounter((prevState) => ({ ...prevState, min: 1 }));
		}
	}, [target.data]);

	const changing = (mode: "inc" | "dec") => {
		setTech((prevState) => {
			const { max, min } = counter;
			let count;
			if (mode === "inc") {
				count = prevState.count + 1;
			} else {
				count = prevState.count - 1;
			}
			if (count > max) {
				count = max;
			} else if (count < min) {
				count = min;
			}
			return { ...prevState, count };
		});
	};

	useEffect(() => {
		if (target.active) {
			directoryAPI
				.dropdownThreatTechnicalMeansDetail(
					{
						edit: target.data !== null,
						part: 1,
						count: 50,
					},
					Number(params.threadId),
				)
				.then(({ data }) => {
					setOptions(
						data
							.filter((_) => _.type)
							.map((_) => {
								const from = fromTable[_.from as keyof typeof fromTable];
								return {
									..._,
									id: _.meanId,
									from,
									fullName: `${_.type} ${_.influence} (${from})`,
								};
							}),
					);
				});
		}
		//eslint-disable-next-line
	}, [target.active, params.threadId]);

	return target.active ? (
		<ModalPortal
			title={target.data ? "Редактировать тех. средство" : "Добавить тех. средство"}
			outSide={false}
			size={"sl"}
			handleClose={close}>
			<div className={sass.modal_content_row}>
				<InputTemp
					error={error && !tech.type}
					required
					onSelect={(e) => {
						setTech((prevState) => ({
							...prevState,
							type: e.type,
							from: e.from,
							name: e.influence,
							fullName: `${e.type} ${e.influence} (${e.from})`,
						}));
					}}
					label={"Тип"}
					value={tech.fullName || ""}
					placeholder={"Не выбрано"}
					field={["fullName"]}
					type={"select"}
					options={options}
				/>
				{/*<InputTemp*/}
				{/*	error={error && !tech.type}*/}
				{/*	required*/}
				{/*	label={"Наименование"}*/}
				{/*	value={tech.type}*/}
				{/*	placeholder={"Не выбрано"}*/}
				{/*	onChange={({ target }) => setTech((prevState) => ({ ...prevState, name: target.value }))}*/}
				{/*/>*/}
				<Counter
					value={tech.count}
					plus={() => changing("inc")}
					minus={() => changing("dec")}
					onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
						let value = Number(target.value);
						if (value > counter.max) {
							value = counter.max;
						} else if (value < counter.min) {
							value = counter.min;
						}
						setTech((prevState) => ({ ...prevState, count: Number(value) }));
					}}
				/>
			</div>
			<div className={sass.btns}>
				<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button onClick={validate}>Готово</Button>
			</div>
		</ModalPortal>
	) : null;
};

export const ModalTemplateModel: React.FC<{
	target: { active: boolean; data: null | number; mode: "create" | "select" };
	close: () => void;
}> = ({ target, close }) => {
	/* логика для создания нового шаблона */
	const [pattern, setPattern] = useState({
		name: "",
		comment: "",
	});

	const [responseError, setResponseError] = useState(false);

	const changeCreatePattern = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { value, name } = e.target;
		setPattern((prevState) => ({ ...prevState, [name]: value }));
	};

	const savePattern = () => {
		organizationAPI
			.objectThreatModelTemplateSaveCreate(target.data!, pattern)
			.then(close)
			.catch((e) => {
				if (e.response.status !== 500) {
					setResponseError(true);
					setTimeout(() => {
						setResponseError(false);
					}, 2000);
				}
			});
	};

	const { error: errorPattern, validate: validatePattern } = useValidate(pattern, ["name"], savePattern);

	/* логика для создания нового шаблона */
	/* логика для применения шаблона */
	const [options, setOptions] = useState<{ id: number; name: string }[]>([]);
	const [checkPattern, setCheckPattern] = useState<{ template_id: number; name: string; comment: string }>({
		template_id: NaN,
		name: "",
		comment:''
	});

	const [searchOptions, setSearchOptions] = useState("");

	const query = useDebounce(searchOptions, 400);

	const selectPattern = (e: { id: number; name: string; comment: string }) => {
		setCheckPattern({ template_id: e.id, name: e.name,comment:e.comment });
	};

	const applyPattern = () => {
		// organizationAPI.objectThreatModelTemplateApplyDetail(target.data!, checkPattern.template_id).then(close);
	};

	const { error: errorDownload, validate: validateDownload } = useValidate(checkPattern, ["name"], applyPattern);
	/* логика для применения шаблона */

	useEffect(() => {
		if (target.mode === "select" && target.data) {
			organizationAPI
				.objectThreatModelTemplateListDetail(target.data!, {
					page: 1,
					num: 30,
					query,
				})
				.then(({ data }) => {
					setOptions(
						data.reduce((acc: { id: number; name: string; comment: string }[], item) => {
							const { id, name,comment } = item;
							acc.push({ id, name,comment:comment??'' });
							return acc;
						}, []),
					);
				});
		} else {
			setOptions([]);
		}
		return () => {
			setPattern({ name: "", comment: "" });
			setCheckPattern({ template_id: NaN, name: "",comment:'' });
		};
		//eslint-disable-next-line
	}, [target.active, target.mode, query]);

	return target.active ? (
		<ModalPortal
			title={target.mode === "create" ? "Сохранение шаблона" : "Выберите шаблон МУ"}
			outSide={false}
			handleClose={close}>
			{target.mode === "create" ? (
				<div className={sass.modal_content}>
					<InputTemp
						error={errorPattern && !pattern.name}
						errorText={responseError ? "Такое имя уже существует" : ""}
						value={pattern.name}
						onChange={changeCreatePattern}
						name={"name"}
						required
						label={"Наименование"}
						placeholder={"Введите название "}
					/>
					<TextArea
						value={pattern.comment}
						onChange={changeCreatePattern}
						name={"comment"}
						label={"Комментарий"}
						placeholder={"Введите комментарий "}
					/>
				</div>
			) : (
				<div className={sass.modal_content}>
					<InputTemp
						error={errorDownload && !checkPattern.name}
						required
						value={searchOptions || checkPattern.name || ""}
						onChange={({ target }) => {
							const { value } = target;
							setSearchOptions(value);
						}}
						onSelect={selectPattern}
						label={"Шаблон"}
						placeholder={"Не выбрано"}
						field={["name"]}
						options={options}
					/>
					{checkPattern.comment && <div className={sass.comment_block}>
						<span>Комментарий</span>
						<span>{checkPattern.comment}</span>
					</div>}
				</div>
			)}
			<div className={sass.btns}>
				<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button onClick={target.mode === "create" ? validatePattern : validateDownload}>Готово</Button>
			</div>
		</ModalPortal>
	) : null;
};

export const ConfirmRemoveTechModal: React.FC<{ close: () => void; ok: () => void; target: boolean }> = ({
	close,
	ok,
	target,
}) => {
	return target ? (
		<ModalPortal outSide={false} title={"Удалить тех. средство"} handleClose={close}>
			<div className={sass.btns_nm}>
				<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button color={BUTTON_COLORS.ERROR} onClick={ok}>
					Удалить
				</Button>
			</div>
		</ModalPortal>
	) : null;
};
export const ConfirmRemoveTableItem: React.FC<{ close: () => void; ok: () => void; target: boolean }> = ({
	close,
	ok,
	target,
}) => {
	return target ? (
		<ModalPortal outSide={false} title={"Удалить строку"} handleClose={close}>
			<div className={sass.btns_nm}>
				<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button color={BUTTON_COLORS.ERROR} onClick={ok}>
					Удалить
				</Button>
			</div>
		</ModalPortal>
	) : null;
};

const initRow: Omit<ITableContent, "id"> = {
	name: "",
	level: "",
	accessType: "",
	category: "",
	permission: "",
};

export const ModalTable: React.FC<{
	ok: (data: typeof initRow, mode: "create" | "edit") => void;
	target: { active: boolean; data: null | typeof initRow };
	close: () => void;
}> = ({ ok, target, close }) => {
	const [row, setRow] = useState(initRow);

	useEffect(() => {
		if (target.data) {
			setRow(target.data);
		} else {
			setRow(initRow);
		}
	}, [target]);

	const { error, validate } = useValidate(row, ["name", "level", "category", "permission", "accessType"], () => {
		if (target.data) {
			ok(row, "edit");
		} else {
			ok(row, "create");
		}
	});

	return target.active ? (
		<ModalPortal title={target.data ? "Редактировать строку" : "Добавить строку"} outSide={false} handleClose={close}>
			<div className={sass.modal_content}>
				<InputTemp
					error={error && !row.name}
					required
					value={row.name}
					label={"Группа пользователей"}
					name={"name"}
					onChange={(e) => {
						const { name, value } = e.target;
						setRow((prevState) => ({ ...prevState, [name]: value }));
					}}
					placeholder={"Введите текст"}
				/>
				<InputTemp
					error={error && !row.permission}
					required
					value={row.permission}
					label={"Авторизация"}
					name={"permission"}
					onChange={(e) => {
						const { name, value } = e.target;
						setRow((prevState) => ({ ...prevState, [name]: value }));
					}}
					placeholder={"Введите текст"}
				/>
				<InputTemp
					error={error && !row.category}
					required
					value={row.category}
					label={"Категория пользователей"}
					name={"category"}
					onChange={(e) => {
						const { name, value } = e.target;
						setRow((prevState) => ({ ...prevState, [name]: value }));
					}}
					placeholder={"Введите текст"}
				/>
				<InputTemp
					error={error && !row.level}
					required
					value={row.level}
					label={"Уровень пользователей"}
					name={"level"}
					onChange={(e) => {
						const { name, value } = e.target;
						setRow((prevState) => ({ ...prevState, [name]: value }));
					}}
					placeholder={"Введите текст"}
				/>
				<InputTemp
					error={error && !row.accessType}
					required
					value={row.accessType}
					label={"Типы доступа"}
					name={"accessType"}
					onChange={(e) => {
						const { name, value } = e.target;
						setRow((prevState) => ({ ...prevState, [name]: value }));
					}}
					placeholder={"Введите текст"}
				/>
			</div>
			<div className={sass.btns}>
				<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button onClick={validate}>Готово</Button>
			</div>
		</ModalPortal>
	) : null;
};
